module.exports = __webpack_public_path__ + "img/103058.550190af.png";